import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const rsvptemplates = {
  state: () => ({
    items: [],
    filter: {
      searchTerm: null,
      skip: 0,
      take: 20,
      total: 0,
      page: 1,
    },
    selectedItems: [],
    loading: true,
  }),
  mutations: {
    setRSVPTemplates(state, payload) {
      state.items = payload.items;
      state.filter.total = payload.total;
    },
    setSelectedRSVPTemplates(state, payload) {
      state.selectedItems = payload;
    },
    setRSVPTemplatePage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getRSVPTemplates");
    },
    setRSVPTemplateTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getRSVPTemplates");
    },
  },
  actions: {
    async getRSVPTemplates(store) {
      store.state.loading = true;
      await axios
        .post("invitation/loadschemes")
        .then((res) => {
          store.state.loading = false;
          return store.commit("setRSVPTemplates", res.data.data);
        });
    },
    async toggleRSVPTemplate(store, payload) {
      var res = await axios.post("RSVPTemplate/toggleisactive", {
        id: store.state.items[payload.index].id,
      });
      return res.data;
    },
    async deleteRSVPTemplate(store, payload) {
      await axios
        .post("invitation/deletescheme", {
          id: store.state.items[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.items.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);
            if (store.state.items.length == 0 && store.state.filter.page != 1) {
              this.commit("setRSVPTemplatePage", store.state.filter.page - 1);
            }
            store.state.filter.total = store.state.filter.total - 1;
          }
        });
    },
  },
  getters: {},
};
export default rsvptemplates;



// WEBPACK FOOTER //
// ./src/store/rsvptemplates.js